<template>
  <div>
    <a
      class="flex p-2 my-1 text-left text-black transition-all duration-300 rounded cursor-pointer hover:bg-gray-100"
      :class="{ 'items-center': isOneLine, 'bg-gray-100': isSelected }"
      @click="viewProfile()"
      data-qa="search_results"
      data-test-id="search-results"
    >
      <div class="mr-2">
        <p-avatar
          data-qa="club_logo"
          :kind="'club'"
          :imageUrl="imageUrl"
          :size="'xs'"
        />
      </div>

      <div class="flex flex-col flex-1">
        <div class="font-semibold text-gray-900 ds-text-sm flex justify-start">
          <div class="w-full">
            <MatchText :query="query" :parts="data.name.split(' ')" />
          </div>
          <div><!--Fav/Interested --></div>
        </div>

        <!-- City, State -->
        <DetailLine>{{ cityState }}</DetailLine>
        <div class="flex items-center">
          <!-- Club, HS  -->
          <DetailLine>{{ data.teamCount }} Teams</DetailLine>
          <span class="text-gray-500 mx-1">&bull;</span>
          <DetailLine>{{ data.athleteCount }} Athletes</DetailLine>
        </div>
      </div>
    </a>
    <!-- divider -->
    <div class="h-1px bg-gray-300 w-full" v-if="!isLast"></div>
  </div>
</template>

<script>
import { PAvatar } from '@sportsrecruits/playbook';
import MatchText from "./MatchText";
import DetailLine from "./ResultItemDetailLine";

export default {
  components: {
    PAvatar,
    MatchText,
    DetailLine,
  },

  props: {
    data: { type: Object, required: true },
    query: { type: String, required: true },
    isSelected: { type: Boolean, default: false },
    isLast: { type: Boolean, default: false },
  },

  computed: {
    cityState() {
      let separator = '';
      if(this.data.city.length && this.data.state.length){
        separator = ', ';
      }
        return this.data.city + separator + this.data.state;
    },

    imageUrl() {
      return this.image ? this.image.url : null;
    },

  },

  methods: {
    viewProfile() {
      this.$emit("clicked", this.data);
    },
  },

  watch: {
    isSelected(is) {
      if (is) {
        const scrollContainer = $(this.$el)
          .closest("[data-scroll-container]")
          .get(0);

        if (
          this.$el.offsetTop + $(this.$el).outerHeight() >
          scrollContainer.scrollTop + $(scrollContainer).innerHeight()
        ) {
          scrollContainer.scrollTo(
            0,
            Math.max(
              0,
              this.$el.offsetTop -
                $(scrollContainer).innerHeight() +
                $(this.$el).outerHeight()
            )
          );
        } else if (this.$el.offsetTop < scrollContainer.scrollTop) {
          scrollContainer.scrollTo(0, this.$el.offsetTop);
        }
      }
    },
  },
};
</script>
